module.exports = __webpack_public_path__ + "assets/img/1436.c636ed45.png";